import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";

import { Config, defaultConfig } from "../Config";
import DeviceConfigDetails from "../device-config-details/DeviceConfigDetails";
import { createConfig } from "../../../apiCalls/config/config";
import { setAlert } from "../../../redux/actions/actions";
import { formatErrorResponse } from "../../../utils/stringUtils";

const CreateDeviceConfigPage: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const goBack = () => {
    history.push("/config/devices/config");
  };

  const handleCreate = async (newConfig: Config) => {
    setLoading(true);
    const res = await createConfig({
      ...newConfig,
      contentsBase64: newConfig?.contentsBase64?.split("base64,").pop() || null,
    });
    setLoading(false);
    if (res?.data) {
      dispatch(setAlert(`Config ${newConfig?.version} created`, "success"));
      goBack();
    } else {
      dispatch(setAlert(formatErrorResponse(res), "error"));
    }
  };

  return (
    <DeviceConfigDetails
      initialConfig={defaultConfig}
      title="Create configuration"
      isLoading={loading}
      handleSave={handleCreate}
      handleCancel={goBack}
      isCreating={true}
    />
  );
};

export default CreateDeviceConfigPage;
